import { useAppSelector } from 'shared/lib';

import { whiteLabelAffIdSelector } from 'entities/whiteLabels';

import { DefaultFormStepHeaders, PartnerFormStepHeadersConfig } from './FormStepHeaders.config';

export const useFormStepHeadersConfig = () => {
  const partnerId = useAppSelector(whiteLabelAffIdSelector);

  if (!partnerId) {
    return {
      headersConfig: DefaultFormStepHeaders,
      isAlwaysShowDescription: false,
    };
  }

  const WlFormStepHeadersConfig = PartnerFormStepHeadersConfig[partnerId] || null;

  if (!WlFormStepHeadersConfig) {
    return {
      headersConfig: DefaultFormStepHeaders,
      isAlwaysShowDescription: false,
    };
  }

  return {
    headersConfig: WlFormStepHeadersConfig,
    isAlwaysShowDescription: true,
  };
};
